import {Dispatch} from 'redux';
import {menuTypes} from '../constanst/index';

export const showDrawner=()=>{
    return {
        type:menuTypes.MENU_SHOWDRAWER
    }
}

export const closeDrawner=()=>{
    return {
        type:menuTypes.MENU_CLOSEDRAWER
    }
}

export const menuShowDrawner = () =>{
    return (dispatch:Dispatch)=>{
        dispatch(showDrawner())
    }
}

export const itemSelected=(item:string)=>{
    return {
        type:menuTypes.MENU_ITEM_SELECTED,
        payload:item
    }
}

export const fullScreen=(isfullScreen:boolean)=>{
    return {
        type:menuTypes.MENU_FULLSCREAN,
        payload:isfullScreen
    }
}

export const menuCloseDrawner = () =>{
    return (dispatch:Dispatch)=>{
        dispatch(closeDrawner())
    }
}

export const menuFullScreen=(isfullScreen:boolean)=>{
    return(dispatch:Dispatch)=>{
        dispatch(fullScreen(isfullScreen));
    }
}

export const menuItemSelected=(item:string)=>{
    return(dispatch:Dispatch)=>{
        dispatch(itemSelected(item));
    }
}
